import React from 'react';
import { theme } from '../../config/theme';

const FormTextarea = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  required,
  disabled,
  placeholder,
  helperText,
  rows = 3,
  ...props
}) => {
  const hasError = touched && error;

  const containerStyles = {
    marginBottom: theme.spacing.lg,
  };

  const labelStyles = {
    display: 'block',
    marginBottom: theme.spacing.xs,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.colors.text.primary,
  };

  const textareaStyles = {
    width: '100%',
    padding: theme.spacing.md,
    fontSize: theme.typography.fontSize.base,
    border: `1px solid ${hasError ? theme.colors.error : theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    outline: 'none',
    transition: theme.transitions.base,
    fontFamily: 'inherit',
    resize: 'vertical',
    backgroundColor: disabled ? theme.colors.gray[50] : theme.colors.white,
  };

  const helperTextStyles = {
    marginTop: theme.spacing.xs,
    fontSize: theme.typography.fontSize.xs,
    color: hasError ? theme.colors.error : theme.colors.text.secondary,
  };

  return (
    <div style={containerStyles}>
      {label && (
        <label htmlFor={name} style={labelStyles}>
          {label}
          {required && <span style={{ color: theme.colors.error }}> *</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        style={textareaStyles}
        {...props}
      />
      {(hasError || helperText) && (
        <div style={helperTextStyles}>
          {hasError ? error : helperText}
        </div>
      )}
    </div>
  );
};

export default FormTextarea;